import Api from "../../services/Api.ts";
import {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router";
import Breadcrumbs, {Crumb} from "../../components/Breadcrumbs/Breadcrumbs.tsx";

interface RespondentInterface {
  id: string
  name: string
  debug: boolean
  completed: string
  link: string
}

interface SurveyRequest {
  id: string
  created: string
  deadline: string
  respondents: Array<RespondentInterface>
}

interface DataInterface {
  request: SurveyRequest
  surveyId: string
  surveyName: string
  categoryId: string
  categoryName: string
  completed: number
}

export default function SurveyRequest() {
  const api = Api.getInstance();
  const { requestId } = useParams();
  const [data, setData] = useState<DataInterface | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get('customer/request/' + requestId).then(response => {
      if (response.json.status === "ok") {
        setData(response.json.data);
        setLoaded(true)
      }
    })
  }, []);

  if (!loaded || !data) {
    return  <div className="main">Loading...</div>
  }

  const crumbs: Array<Crumb> = [
    {
      name: "Categories",
      link: "/categories"
    },
    {
      name: data.categoryName,
      link: "/categories/" + data.categoryId,
    },
    {
      name: "Survey: " + data.surveyName,
      link: "/categories/survey/" + data.surveyId,
    },
    {
      name: "Feedback requests",
      link: "/categories/survey/" + data.surveyId + "/requests",
    },
    {
      name: "Request"
    }
  ]

  return (
    <div className="main">
      <Breadcrumbs crumbs={crumbs}/>
      <div className="text-3xl font-medium mt-4">Feedback request for {data.surveyName}</div>

      <p className="mt-4 text-neutral-400">Created: {data.request.created.substring(0, 10)}</p>
      <p className="mt-2 text-neutral-400">Deadline: {data.request.deadline.substring(0, 10)}</p>
      <p className="mt-2 text-neutral-400">Respondents answered: {data.completed}</p>

      {
        data.request.respondents.map((respondent, i) => (
          <div className="mt-2" key={"r_" + i}>
            {respondent.name}: {respondent.id}
            {
              respondent.debug &&
              <>
                {
                  respondent.completed ? (
                    <span className="ml-4">Completed: {respondent.completed}</span>
                  ) : (
                      <span className="ml-4"><a href={respondent.link}>To survey</a></span>
                  )
                }
              </>
            }
          </div>
        ))
      }


    </div>
  )
}